import React, {Component} from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import ExclusionInfo from './atoms/exclusion-info';
import PlayerExclusionSwitcher from './player-exclusion-switcher';
import PlayerExclusionsStateList from './player-exclusions-state-list';

class RankPlayerExclusionState extends Component {
    getTooltipByMode() {
        const {players, playerId, playerMode, modesConfig} = this.props;
        const player = players.getPlayer(playerId);
        const modeConfig = modesConfig.getConfig(playerMode);

        const tooltip = [];
        if (player.isExcludedBy(Const.EXCLUDED_BY_ORDER_RANGE)) {
            tooltip.push('Order');
        }
        if (player.isExcludedBy(Const.EXCLUDED_BY_CONFIRMED_RANGE)) {
            tooltip.push('Confirmed');
        }
        if (player.isExcludedBy(Const.EXCLUDED_BY_LINE_GROUPS_RANGE)) {
            tooltip.push('Line Grouping');
        }
        if (player.isExcludedByPoints(playerMode)) {
            tooltip.push(`${modeConfig.getLabel()} Fantasy Points`);
        }
        if (player.isExcludedBySalary(playerMode)) {
            tooltip.push(`${modeConfig.getLabel()} Salary`);
        }
        return tooltip;
    }

    isSatisfiedForPlayerExclusionsStateList() {
        const {activeMode} = this.props;

        return inArray(activeMode, [Const.OVERALL_MODE, Const.LOCKED_MODE]);
    }

    isSatisfiedForExclusionInfo() {
        const {activeMode} = this.props;

        return Const.EXCLUDED_MODE === activeMode;
    }

    render() {
        const {playerId, playerMode} = this.props;

        if (this.isSatisfiedForPlayerExclusionsStateList()) {
            return <PlayerExclusionsStateList playerId={playerId} />;
        }

        if (this.isSatisfiedForExclusionInfo()) {
            const tooltip = this.getTooltipByMode();
            if (!isEmpty(tooltip)) {
                return <ExclusionInfo tooltip={tooltip} />;
            }
        }

        return <PlayerExclusionSwitcher playerId={playerId} activeMode={playerMode} />;
    }
}

function mapStatesToProps(state) {
    const {playersData, modesConfig} = state;

    return {
        players: playersData.players,
        modesConfig,
    };
}

export default connect(mapStatesToProps)(RankPlayerExclusionState);

export {RankPlayerExclusionState};
